import { IconProps } from '@euler/app/components/icons/types';
import { useSvgProps } from '@euler/app/components/icons/util';
import { FC, memo } from 'react';
import { Path, Svg } from 'react-native-svg';

export const ImageIcon: FC<IconProps> = memo(props => {
  const { fill = '#000', ...svgProps } = useSvgProps(props, 50, 50);
  return (
    <Svg viewBox="0 0 1024 1024" fill="none" {...svgProps}>
      <Path
        d="M984.615385 196.923077c0-43.323077-35.446154-78.769231-78.769231-78.769231H118.153846c-43.323077 0-78.769231 35.446154-78.769231 78.769231v630.153846c0 43.323077 35.446154 78.769231 78.769231 78.769231h787.692308c43.323077 0 78.769231-35.446154 78.769231-78.769231V196.923077zM779.815385 748.307692h-571.076923c-23.630769 0-37.415385-25.6-25.6-45.292307l173.292307-301.292308c7.876923-13.784615 25.6-13.784615 33.476923 0l104.369231 179.2c7.876923 11.815385 25.6 13.784615 33.476923 1.969231l84.676923-122.092308c7.876923-11.815385 25.6-11.815385 33.476923 0L801.476923 708.923077c11.815385 17.723077 0 39.384615-21.661538 39.384615zM728.615385 393.846154c-43.323077 0-78.769231-35.446154-78.769231-78.769231s35.446154-78.769231 78.769231-78.769231 78.769231 35.446154 78.76923 78.769231-35.446154 78.769231-78.76923 78.769231z"
        fill={fill}
      />
      <Path
        d="M746.4 524.6c38.8 0 70.4-31.6 70.4-70.4s-31.4-70.4-70.4-70.4c-38.8 0-70.4 31.4-70.4 70.4S707.4 524.6 746.4 524.6z"
        fill={fill}
      />
    </Svg>
  );
});
